module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/investigation-docs/investigation-docs.component.css
// module id = ./src/app/investigation-docs/investigation-docs.component.css
// module chunks = main